import { FC } from 'react';
import { ArrowDown } from 'tedooo-web-design-system/icons';

const Arrow: FC<any> = ({ currentSlide, slideCount, ...props }) => (
  <div {...{ ...props, currentslide: currentSlide, slidecount: slideCount }}>
    <ArrowDown className="button-carousel" />
  </div>
);

export const MultiItemCarouselSettings = {
  slidesToShow: 2,
  slidesToScroll: 2,
  initialSlide: 0,
  className: 'shop-item',
  dots: false,
  infinite: false,
  speed: 500,
  nextArrow: <Arrow />,
  prevArrow: <Arrow />,
  responsive: [
    {
      breakpoint: 600,
      settings: {
        nextArrow: undefined,
        prevArrow: undefined,
      },
    },
  ],
};
